import { Box, BoxProps, Icon, IconProps, Text, Tooltip } from '@betterleap/ui';
import React, { useState } from 'react';
import styles from './SidebarItem.module.scss';

interface SidebarItemProps extends BoxProps {
  title: string;
  icon?: string | JSX.Element;
  onClick?: (e?: React.MouseEvent<HTMLElement>) => void;
  hidden?: boolean;
  collapsed?: boolean;
  dataCy?: string;
  collapsable?: boolean;
}

const SidebarItem = ({
  title,
  icon,
  onClick,
  hidden,
  css,
  collapsed,
  dataCy,
  collapsable = false,
  ...rest
}: SidebarItemProps) => {
  const [open, isOpen] = useState<boolean>();

  if (hidden) return null;

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    if (collapsable) {
      isOpen(!open);
    }
    onClick?.(e);
  };

  return (
    <Tooltip
      content={title}
      side='right'
      className={`${!collapsed ? styles.collapsed : ''}`}
    >
      <Box
        as='nav'
        css={{
          display: 'flex',
          mt: 8,
          py: 14,
          px: 16,
          borderRadius: '$xl',
          alignItems: 'center',
          color: '$neutral-blue-700',
          cursor: 'pointer',
          justifyContent: 'space-between',
          mediaMd: {
            width: !collapsed ? '100%' : 'unset',
            overflow: !collapsed ? 'hidden' : 'unset',
          },
          ...css,
        }}
        key={title}
        onClick={handleClick}
        data-cy={dataCy}
        {...rest}
      >
        {icon &&
          (React.isValidElement(icon) ? (
            <Box css={{ mr: collapsed ? 0 : 12 }}>
              {React.cloneElement<IconProps>(icon as JSX.Element)}
            </Box>
          ) : (
            <img
              src={icon as string}
              alt='icon'
              className={`mr-2 ${styles.sidebar_icon}`}
              aria-hidden
            />
          ))}
        {!collapsed && (
          <>
            <Text size='base' inherit>
              {title}
            </Text>
            <Icon name={open ? 'chevron-down' : 'chevron-up'} />
          </>
        )}
      </Box>
    </Tooltip>
  );
};

export default SidebarItem;
